(function () {
  function initSliderCarousel(root) {
    if (root.dataset.sliderCarouselInit === 'true') return;
    root.dataset.sliderCarouselInit = 'true';
    var panels = root.querySelectorAll('[data-tab-panel]');
    var tabButtons = root.querySelectorAll('[data-slider-carousel-tab]');
    var hasTabs = tabButtons.length > 0;
    var activePanelIndex = 0;
    var autoplayTimer = null;
    var autoplay = root.dataset.autoplay === 'true';
    var autoplayDelay = parseInt(root.dataset.autoplayDelay, 10) || 5000;

    var state = {
      index: 0,
      track: null,
      viewport: null,
      dots: [],
      slides: [],
    };

    function getPanel(index) {
      return panels[index] || panels[0];
    }

    var prevBtn = root.querySelector('[data-slider-carousel-prev]');
    var nextBtn = root.querySelector('[data-slider-carousel-next]');
    var resizeRaf = null;
    var viewportObserver = null;

    function observeViewport() {
      if (viewportObserver) viewportObserver.disconnect();
      if (!state.viewport || typeof ResizeObserver === 'undefined') return;

      viewportObserver = new ResizeObserver(function () {
        if (resizeRaf) return;
        resizeRaf = requestAnimationFrame(function () {
          resizeRaf = null;
          setActive(state.index);
        });
      });
      viewportObserver.observe(state.viewport);
    }

    function bindPanel(index) {
      var panel = getPanel(index);
      if (!panel) return;

      state.track = panel.querySelector('[data-slider-carousel-track]');
      state.viewport = panel.querySelector('[data-slider-carousel-viewport]');
      state.slides = panel.querySelectorAll('[data-slider-carousel-slide]');
      state.dots = panel.querySelectorAll('[data-slider-carousel-dot]');
      state.index = 0;
      observeViewport();
    }

    function getMaxIndex() {
      return Math.max(0, state.slides.length - 1);
    }

    function getCenterOffset(slideEl) {
      if (!slideEl || !state.viewport) return 0;
      var viewportWidth = state.viewport.offsetWidth;
      var slideWidth = slideEl.offsetWidth;
      return slideEl.offsetLeft - (viewportWidth - slideWidth) / 2;
    }

    function setActive(i) {
      if (!state.slides.length) return;

      state.index = Math.max(0, Math.min(getMaxIndex(), i));

      for (var s = 0; s < state.slides.length; s++) {
        state.slides[s].classList.toggle('is-active', s === state.index);
      }

      var slide = state.slides[state.index];
      if (!slide || !state.track) return;

      var centerOffset = getCenterOffset(slide);
      var minOffset = Math.max(0, getCenterOffset(state.slides[0]));
      var maxOffset = getCenterOffset(state.slides[state.slides.length - 1]);
      centerOffset = Math.min(maxOffset, Math.max(minOffset, centerOffset));
      state.track.style.transform = 'translate3d(' + -centerOffset + 'px, 0, 0)';

      if (prevBtn) prevBtn.disabled = state.index <= 0;
      if (nextBtn) nextBtn.disabled = state.index >= getMaxIndex();

      for (var d = 0; d < state.dots.length; d++) {
        var dotIndex = parseInt(state.dots[d].getAttribute('data-slider-carousel-dot'), 10);
        var isDotActive = dotIndex === state.index;
        state.dots[d].classList.toggle('is-active', isDotActive);
        if (isDotActive) {
          state.dots[d].setAttribute('aria-current', 'true');
        } else {
          state.dots[d].removeAttribute('aria-current');
        }
      }
    }

    function resetAutoplay() {
      if (autoplayTimer) clearInterval(autoplayTimer);
      if (!autoplay || state.slides.length <= 1) return;

      autoplayTimer = setInterval(function () {
        var next = state.index >= getMaxIndex() ? 0 : state.index + 1;
        setActive(next);
      }, autoplayDelay);
    }

    function goTo(direction) {
      setActive(state.index + direction);
      resetAutoplay();
    }

    function scrollTabIntoView(tabButton) {
      var tabsEl = root.querySelector('[data-slider-carousel-tabs]');
      if (!tabsEl || !tabButton) return;

      var maxScroll = tabsEl.scrollWidth - tabsEl.clientWidth;
      if (maxScroll <= 0) return;

      var scrollLeft = tabButton.offsetLeft - (tabsEl.clientWidth - tabButton.offsetWidth) / 2;
      tabsEl.scrollTo({
        left: Math.max(0, Math.min(scrollLeft, maxScroll)),
        behavior: 'smooth',
      });
    }

    function showPanel(index, options) {
      options = options || {};
      if (!panels.length) return;

      activePanelIndex = Math.max(0, Math.min(panels.length - 1, index));

      for (var p = 0; p < panels.length; p++) {
        var isActive = p === activePanelIndex;
        panels[p].hidden = !isActive;
        panels[p].classList.toggle('is-active', isActive);
      }

      for (var t = 0; t < tabButtons.length; t++) {
        var tabIndex = parseInt(tabButtons[t].getAttribute('data-slider-carousel-tab'), 10);
        var tabActive = tabIndex === activePanelIndex;
        tabButtons[t].classList.toggle('is-active', tabActive);
        tabButtons[t].setAttribute('aria-selected', tabActive ? 'true' : 'false');
        if (tabActive && options.scrollTab !== false) {
          scrollTabIntoView(tabButtons[t]);
        }
      }

      bindPanel(activePanelIndex);

      requestAnimationFrame(function () {
        setActive(0);
        resetAutoplay();
      });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        goTo(-1);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        goTo(1);
      });
    }

    root.addEventListener('click', function (event) {
      var dot = event.target.closest('[data-slider-carousel-dot]');
      if (dot && getPanel(activePanelIndex).contains(dot)) {
        var targetIndex = parseInt(dot.getAttribute('data-slider-carousel-dot'), 10);
        if (isNaN(targetIndex)) return;
        setActive(targetIndex);
        resetAutoplay();
        return;
      }

      var tab = event.target.closest('[data-slider-carousel-tab]');
      if (tab) {
        var tabIdx = parseInt(tab.getAttribute('data-slider-carousel-tab'), 10);
        if (isNaN(tabIdx) || tabIdx === activePanelIndex) return;
        showPanel(tabIdx);
      }
    });

    var touchStartX = 0;
    var touchDeltaX = 0;
    var touchTracking = false;

    function isTabsTouchTarget(target) {
      return Boolean(
        target &&
          target.closest &&
          target.closest(
            '[data-slider-carousel-tabs], [data-slider-carousel-tabs-wrap], [data-slider-carousel-tabs-prev], [data-slider-carousel-tabs-next]'
          )
      );
    }

    root.addEventListener(
      'touchstart',
      function (e) {
        if (isTabsTouchTarget(e.target)) {
          touchTracking = false;
          touchDeltaX = 0;
          return;
        }

        var panel = getPanel(activePanelIndex);
        if (!state.viewport || !panel || !panel.contains(e.target)) {
          touchTracking = false;
          touchDeltaX = 0;
          return;
        }

        touchTracking = true;
        touchStartX = e.changedTouches[0].screenX;
        touchDeltaX = 0;
      },
      { passive: true }
    );

    root.addEventListener(
      'touchmove',
      function (e) {
        if (!touchTracking) return;
        touchDeltaX = e.changedTouches[0].screenX - touchStartX;
      },
      { passive: true }
    );

    root.addEventListener(
      'touchend',
      function () {
        if (!touchTracking) return;
        touchTracking = false;
        if (Math.abs(touchDeltaX) < 40) return;
        goTo(touchDeltaX < 0 ? 1 : -1);
        touchDeltaX = 0;
      },
      { passive: true }
    );

    root.addEventListener(
      'touchcancel',
      function () {
        touchTracking = false;
        touchDeltaX = 0;
      },
      { passive: true }
    );

    window.addEventListener('resize', function () {
      if (resizeRaf) return;
      resizeRaf = requestAnimationFrame(function () {
        resizeRaf = null;
        setActive(state.index);
      });
    });

    function initTabScroll() {
      var tabsWrap = root.querySelector('[data-slider-carousel-tabs-wrap]');
      var tabsEl = root.querySelector('[data-slider-carousel-tabs]');
      var tabsPrev = root.querySelector('[data-slider-carousel-tabs-prev]');
      var tabsNext = root.querySelector('[data-slider-carousel-tabs-next]');

      if (!tabsWrap || !tabsEl) return;

      var nudged = false;

      function updateTabScrollState() {
        var maxScroll = tabsEl.scrollWidth - tabsEl.clientWidth;
        var scrollable = maxScroll > 4;

        tabsWrap.classList.toggle('is-scrollable', scrollable);

        if (!scrollable) {
          tabsWrap.classList.remove('has-scroll-left', 'has-scroll-right');
          if (tabsPrev) tabsPrev.hidden = true;
          if (tabsNext) tabsNext.hidden = true;
          return;
        }

        var atStart = tabsEl.scrollLeft <= 4;
        var atEnd = tabsEl.scrollLeft >= maxScroll - 4;

        tabsWrap.classList.toggle('has-scroll-left', !atStart);
        tabsWrap.classList.toggle('has-scroll-right', !atEnd);

        if (tabsPrev) tabsPrev.hidden = atStart;
        if (tabsNext) tabsNext.hidden = atEnd;

        if (!nudged && !atEnd && window.matchMedia('(min-width: 1024px)').matches) {
          nudged = true;
          if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            window.setTimeout(function () {
              tabsEl.scrollTo({ left: 28, behavior: 'smooth' });
              window.setTimeout(function () {
                tabsEl.scrollTo({ left: 0, behavior: 'smooth' });
              }, 500);
            }, 700);
          }
        }
      }

      function scrollTabs(direction) {
        tabsEl.scrollBy({ left: direction * Math.max(160, tabsEl.clientWidth * 0.55), behavior: 'smooth' });
      }

      if (tabsPrev) {
        tabsPrev.addEventListener('click', function () {
          scrollTabs(-1);
        });
      }

      if (tabsNext) {
        tabsNext.addEventListener('click', function () {
          scrollTabs(1);
        });
      }

      tabsEl.addEventListener('scroll', updateTabScrollState, { passive: true });

      var tabResizeRaf = null;
      window.addEventListener('resize', function () {
        if (tabResizeRaf) return;
        tabResizeRaf = requestAnimationFrame(function () {
          tabResizeRaf = null;
          updateTabScrollState();
        });
      });

      if (typeof ResizeObserver !== 'undefined') {
        var tabsObserver = new ResizeObserver(updateTabScrollState);
        tabsObserver.observe(tabsEl);
      }

      updateTabScrollState();
    }

    if (hasTabs) {
      initTabScroll();
      showPanel(0, { scrollTab: false });
    } else {
      bindPanel(0);
      requestAnimationFrame(function () {
        setActive(0);
        resetAutoplay();
      });
    }
  }

  function boot() {
    document.querySelectorAll('[data-slider-carousel]').forEach(initSliderCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-slider-carousel]');
    if (root) initSliderCarousel(root);
  });
})();
